import { cleanToken } from '@nitra/components/njs/token.js'

const routes = [
  {
    path: '',
    beforeEnter: (_to, _from, next) => {
      next('/surveys')
    }
  },
  {
    path: '/',
    component: () => import('layouts/Layout.vue'),
    children: [
      {
        path: '/surveys',
        meta: { roles: 'admin-user' },
        component: () => import('pages/Survey.vue')
      },
      {
        path: '/survey/:id',
        name: 'survey',
        meta: { roles: 'admin-user' },
        component: () => import('pages/SurveyInfo.vue')
      },
      {
        path: '/test/:id',
        name: 'test',
        meta: { roles: 'admin-user' },
        component: () => import('pages/Test.vue')
      }
    ]
  },
  {
    path: '/logout',
    beforeEnter: (_to, from, next) => {
      // Записуємо поточний урл в session storage
      // щоб потім на нього повернути після логіну
      sessionStorage.setItem('url-before-logout', from.path)

      // remove auth cookie
      cleanToken()
      next('/login')
    }
  },
  {
    path: '/login',
    component: () => import('layouts/Blank.vue'),
    children: [
      { path: '/login', component: () => import('pages/login/Login.vue') },
      { path: '/code', component: () => import('pages/login/Code.vue') }
    ]
  }
]

// Always leave this as last one
if (process.env.MODE !== 'ssr') {
  routes.push({
    path: '*',
    component: () => import('pages/Error404.vue')
  })
}

export default routes
